function replaceDoubleAsterisksWithTags(inputString) {
    return inputString.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
}

function formatText(rawText) {
    // Split the text into sections based on the newline character (\n)
    const sections = rawText.split('\n');

    // Initialize the formatted HTML string
    let html = '';
    // Iterate through each section
    sections.forEach(section => {
        section = replaceDoubleAsterisksWithTags(section)
        // Check if the section starts with an asterisk (*)
        if (section.trim().startsWith('<b>') && section.trim().endsWith('</b>')) {
            // If it starts and ends with double asterisks (**), treat it as bold text
            html += '<u>' + section.trim() + '</u>';
        } else if (section.trim().startsWith('*')) {
            // If it does, treat it as a list item
            html += '<li>' + section.trim().substring(1) + '</li>';
        } else {
            // Otherwise, treat it as a paragraph
            html += '<p>' + section + '</p>';
        }
    });

    // Wrap the formatted HTML in an unordered list (for list items)
    html = '<ul>' + html + '</ul>';

    return html;
}

function formatTextPdf(rawText) {
    // Split the text into lines
    const lines = rawText.split('\n');
    let content = [];

    lines.forEach(line => {
        line = line.trim();

        if (line.startsWith('**') && line.endsWith('**')) {
            // Highlighted section headers
            content.push({ text: line.replace(/\*\*/g, ''), bold: true, background: 'yellow', fontSize: 16, margin: [0, 5] });
        } else if (line.startsWith('*')) {
            // Bullet points for lists
            content.push({ ul: [line.substring(1).trim()] });
        } else if (line.includes(':')) {
            // Bold labels (for key-value type lines)
            const parts = line.split(':');
            content.push({ text: [{ text: parts[0] + ':', bold: true }, { text: parts.slice(1).join(':') }] });
        } else if (line === '---') {
            // Horizontal line separator
            content.push({ text: '', margin: [0, 5], canvas: [{ type: 'line', x1: 0, y1: 5, x2: 500, y2: 5, lineWidth: 1 }] });
        } else {
            // Default paragraph
            content.push({ text: line, margin: [0, 2] });
        }
    });

    return content;
}

export { formatText, formatTextPdf }